import React from 'react'
import {MetalColor, Finish, Gemstones, NextSteps, RingFaceShape, RaisedOrRecessed, RingFaceSize, ShoulderDesigns} from './shared'

const METAL_COLOR_CARDS = [
  {
    name: "silver_color",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/metal/silver.jpg`,
    label: "White Gold, Silver, Platinum"
  },
  {
    name: "yellow",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/metal/yellow-gold.jpg`,
    label: "Yellow Gold"
  },
  {
    name: "rose",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/metal/rose-gold.jpg`,
    label: "Rose Gold"
  },
  {
    name: "mixed_metals",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/metal/mixed.jpg`,
    label: "Mixed Metals"
  }
]

export const ClassRingMetalColor = props => <MetalColor cards={METAL_COLOR_CARDS} {...props} />

const FINISH_CARDS = [
  {
    name: "polished",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/finish/polished.jpg`,
    label: "Polished"
  },
  {
    name: "brushed",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/finish/brushed.jpg`,
    label: "Brushed"
  },
  {
    name: "oxidized",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/finish/oxidized.jpg`,
    label: "Oxidized"
  },
  {
    name: "enamel",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/finish/enamel.jpg`,
    label: "Enamel"
  }
]

export const ClassRingFinish = props => <Finish cards={FINISH_CARDS} {...props} />

const GEMSTONES_CARDS = [
  {
    name: "no_stone",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/gem/none.jpg`,
    label: "No Stone"
  },
  {
    name: "center_stone",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/gem/center-stone.jpg`,
    label: "Center Stone"
  },
  {
    name: "halo",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/gem/halo.jpg`,
    label: "Halo"
  },
  {
    name: "accent_stones",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/gem/accent-stones.jpg`,
    label: "Accent Stones"
  }
]

export const ClassRingGemstones = props => <Gemstones cards={GEMSTONES_CARDS} {...props} />

const RING_FACE_SHAPE_CARDS = [
  {
    name: "circle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/circle.jpg`,
    label: "Circle"
  },
  {
    name: "portrait_oval",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/portrait-oval.jpg`,
    label: "Portrait Oval"
  },
  {
    name: "landscape_oval",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/landscape-oval.jpg`,
    label: "Landscape Oval"
  },
  {
    name: "square",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/square.jpg`,
    label: "Square"
  },
  {
    name: "portrait_rectangle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/portrait-rectangle.jpg`,
    label: "Portrait Rectangle"
  },
  {
    name: "landscape_rectangle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/landscape-rectangle.jpg`,
    label: "Landscape Rectangle",
    smallText: true
  },
  {
    name: "custom",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/face/custom.jpg`,
    label: "Custom"
  },
]

export const ClassRingFaceShape = props => <RingFaceShape cards={RING_FACE_SHAPE_CARDS} {...props} />

const RAISED_OR_RECESSED_CARDS = [
  {
    name: "raised",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/raised-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/raised-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/raised-3.jpg`,
    ],
    label: "Raised"
  },
  {
    name: "recessed",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/recessed-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/recessed-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/recessed-3.jpg`,
    ],
    label: "Recessed"
  },
  {
    name: "recessed_and_mirrored",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/mirrored-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/mirrored-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/raise-or-recess/mirrored-3.jpg`,
    ],
    label: "Recessed and Mirrored"
  }
]

export const ClassRingRaisedOrRecessed = props => <RaisedOrRecessed cards={RAISED_OR_RECESSED_CARDS} {...props} />

export const ClassRingFaceSize = props => <RingFaceSize
  img="//images.custommade.com/NmDB_mSk1gTgJx9P9Q8AnmWdasI=/custommade-attachments/8970b927e848854_crf_images_7_ring_face_size_49b9d77b9acf21b_1440_copy_5.png"
  {...props}
  />

const SHOULDER_DESIGNS = [
  {
    name: "same_on_both_sides",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/same-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/same-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/same-3.jpg`,
    ],
    label: "Same on both sides"
  },
  {
    name: "different",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/different-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/different-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/different-3.jpg`,
    ],
    label: "Different design on each side"
  },
  {
    name: "no_designs",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/none-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/none-2.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/class/shoulder/none-3.jpg`,
    ],
    label: "No shoulder design"
  }
]

export const ClassRingShoulderDesigns = props => <ShoulderDesigns cards={SHOULDER_DESIGNS} {...props} />

const NEXT_STEPS_CARDS = [
  {
    name: "price",
    description: "Our design experts will prepare some initial quotes for you to review as a starting point for your ring.",
    label: "I’d like to discuss price first."
  },
  {
    name: "questions",
    description: "If you have other things you’d like to discuss before our team gets started, let us know - one of our ring consultants will get in touch.",
    label: "I have questions to ask or other details to share first."
  },
  {
    name: "looking_around",
    description: "Just looking around for now? We’ll hold onto your details and you can let us know when you’re ready to get started.",
    label: "I’m not ready for a consultation yet."
  }
]

export const ClassRingNextSteps = () => <NextSteps cards={NEXT_STEPS_CARDS} />
